import Field from '../../Field';
import terminology from 'javascripts/terminology';
import { type FieldContentsData } from 'javascripts/shared-types';

export class ThemeName extends Field {
  static subqueriesForModel() {
    return { ideaThemes: ['name', 'color'] };
  }

  get title() {
    return `${terminology('Idea theme')} name`;
  }

  exampleContents(): FieldContentsData {
    return {
      tags: [
        { name: `Example ${terminology('idea theme')}`, color: '#666666' },
      ],
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.ideaThemes?.length) {
      return {
        tags: record.ideaThemes.map(({ name }) => {
          return {
            name,
            color: '#666666',
          };
        }),
      };
    }

    return {};
  }
}
